// extracted by mini-css-extract-plugin
export default {"_wrapper":"PatientInfo__wrapper__7+xXN"};